import React from 'react';
import styled from '../../styled';
import { media } from '../../themes/breakpoint';
import Text from '../text';
const BannerWrapper = styled.div `
  display: flex;
  border-radius: 4px;
  box-shadow: 0 0.0625rem 0.1875rem 0
      ${({ theme }) => theme.colors.SHADOW_LIGHT},
    0 0 0.0625rem 0 ${({ theme }) => theme.colors.SHADOW_DEFAULT};
  background-color: ${({ backgroundColor }) => backgroundColor};
  background-image: ${({ backgroundImage }) => backgroundImage && `url(${backgroundImage})`};
  background-repeat: no-repeat;
  background-position: left center;
  background-size: cover;

  ${media.mobile `
    flex-direction: column-reverse;
	`};
`;
const Image = styled.div `
  flex: 1;
  position: relative;
  overflow: hidden;
  background-color: ${({ color }) => color};
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : 'unset')};

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    ${media.mobile `
      position: static;
    `};
  }
`;
const ContentWrapper = styled.div `
  flex: 2;
  padding: 1.5rem 2rem;

  ${media.mobile `
    padding: 1.5rem 1rem;
	`};
`;
const Title = styled.div `
  margin-bottom: 0.5rem;
`;
const Content = styled.div `
  margin-bottom: 1rem;
`;
const Triggers = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  ${media.mobile `
    flex-direction: column;
    align-items: start;
	`};
`;
const Trigger = styled.a `
  margin-right: 0.5rem;

  &:last-child {
    margin-right: 0;
  }

  ${media.mobile `
    margin-right: 0;
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
	`};
`;
const Banner = ({ lang, title, titleColor, content, image, minHeight, triggers = [], backgroundColor, backgroundImage, }) => (React.createElement(BannerWrapper, { backgroundColor: backgroundColor, backgroundImage: backgroundImage },
    React.createElement(ContentWrapper, null,
        title && (React.createElement(Title, null,
            React.createElement(Text, { lang: lang, fontType: "Heading", color: titleColor }, title))),
        content && React.createElement(Content, null, content),
        triggers.length > 0 && (React.createElement(Triggers, null, triggers.map(({ key, link, target = '_blank', renderTrigger }) => (React.createElement(Trigger, { key: key, href: link, target: target }, renderTrigger && renderTrigger())))))),
    image && (React.createElement(Image, { minHeight: minHeight },
        React.createElement("img", { src: image, alt: "Foreground Illustration" })))));
export default Banner;
//# sourceMappingURL=Banner.js.map